import { ActivatedRoute, Params } from "@node_modules/@angular/router";

export const Table29InstallationValues = [
    { "name": "Multi-core cable buried direct", "value": 1 },
    { "name": "Two or three single core cables buried direct", "value": 2 },
    { "name": "Multi-core cable in a wiring enclosure", "value": 3 },
    { "name": "Two single core cables in a wiring enclosure", "value": 4 },
    { "name": "Three single core cables in a wiring enclosure", "value": 5 },
]

export const pdc_calc_color_solid = [
  'rgba(31, 119, 180, 1)',
  'rgba(213, 94, 0, 1)',
  'rgba(46, 125, 50, 1)',
  'rgba(178, 34, 34, 1)',
  'rgba(106, 61, 154, 1)',
  'rgba(107, 114, 128, 1)',
  'rgba(27, 158, 119, 1)',
  'rgba(201, 162, 39, 1)',
  'rgba(76, 106, 146, 1)',
  'rgba(139, 90, 43, 1)'
];
export const pdc_calc_color_transparent = [
  'rgba(31, 119, 180, 0.5)',
  'rgba(213, 94, 0, 0.5)',
  'rgba(46, 125, 50, 0.5)',
  'rgba(178, 34, 34, 0.5)',
  'rgba(106, 61, 154, 0.5)',
  'rgba(107, 114, 128, 0.5)',
  'rgba(27, 158, 119, 0.5)',
  'rgba(201, 162, 39, 0.5)',
  'rgba(76, 106, 146, 0.5)',
  'rgba(139, 90, 43, 0.5)'
];


export const getAllRouteParams = (route: ActivatedRoute): Params => {
    let params: Params = {};

    let currentRoute: ActivatedRoute | null = route;

    while (currentRoute) {
        params = {
            ...params,
            ...currentRoute.snapshot.params
        };

        currentRoute = currentRoute.firstChild;
    }

    return params;
}